import {
  SEGMENT_OPTIONS,
  DEALERSTATE_OPTIONS,
  DEALERRATING_OPTIONS,
} from './longChannelVocabularies';
import { atDialect } from '../../../Components/engine/dialect';

/**
 * Column layout for the long channel's customer list, in the shape `resolveColumns` compiles.
 *
 * Checked in as the default; a saved configuration has the same shape and replaces it. Each entry
 * carries its own label, cell and size, so nothing here needs the column catalogue at render time.
 *
 * `key` is a value path: a customer property, or `attributes.KEY` for a section attribute.
 *
 * `slot` says where a column goes on a card, which is what the mobile list shows instead of a row.
 */

export const LONGCHANNEL_COLUMNS = atDialect([
  {
    key: 'companyName',
    label: 'COMPANY',
    cell: 'title',
    size: { md: 2 },
    noCaption: true,
    slot: 'primary',
    caption: {
      key: 'attributes.DEALERRATING',
      label: 'RATING',
      options: DEALERRATING_OPTIONS,
    },
  },
  {
    key: 'customerCode',
    size: { md: 1 },
    slot: 'secondary',
  },
  {
    key: 'fullName',
    label: 'FINANCIALMANAGER',
    cell: 'text',
    capitalize: true,
    size: { md: 1.2 },
  },
  {
    key: 'mobilePhoneNumber',
    cell: 'phone',
    size: { md: 1.2 },
  },
  {
    key: 'attributes.SEGMENT',
    label: 'SEGMENT',
    cell: 'iconValue',
    size: { md: 1.5 },
    noCaption: true,
    options: SEGMENT_OPTIONS,
  },
  {
    key: 'attributes.HASNATIONALAGREEMENT',
    label: 'NATIONALAGREEMENT',
    cell: 'flag',
  },
  {
    key: 'attributes.DEALERSTATE',
    label: 'STATUS',
    cell: 'status',
    size: { md: 1 },
    noCaption: true,
    slot: 'trailing',
    options: DEALERSTATE_OPTIONS,
  },
  {
    key: 'exportedOn',
    label: 'EXPORTEDON',
    cell: 'monthChip',
    size: { md: 1.2 },
    noCaption: true,
  },
]);
